export default __webpack_public_path__ + "static/pq-full-logo-29b823e5c3a6396d36f2b60c24397447.png";